import { render, staticRenderFns } from "./ProfileDisplay.vue?vue&type=template&id=354e8438&"
import script from "./ProfileDisplay.vue?vue&type=script&lang=js&"
export * from "./ProfileDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports